import { AnalyticsWrapper } from "@mod/core/config/initialize-analytics";
import { PostHogProvider } from "posthog-js/react";
import { Outlet } from "react-router-dom";
import { redirectToNewDomain } from "./lib/redirect-to-new-domain";
import { MainHeader } from "./ui/main-header";

export const {
  ENV_POSTHOG_KEY,
  ENV_POSTHOG_HOST
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
} = dmenv;

export const MainLayout = () => {
  redirectToNewDomain();

  return (
    <PostHogProvider
      apiKey={ENV_POSTHOG_KEY}
      options={{
        api_host: ENV_POSTHOG_HOST
      }}
    >
      <div className="flex flex-col bg-white">
        <MainHeader />
        <AnalyticsWrapper />
        <main className="flex-grow overflow-auto min-h-screen">
          <Outlet />
        </main>
        {/* <FooterWrapper /> */}
      </div>
    </PostHogProvider>
  );
};
